import { render, staticRenderFns } from "./RiseupHeader.vue?vue&type=template&id=26a690f4&scoped=true&"
import script from "./RiseupHeader.vue?vue&type=script&lang=js&"
export * from "./RiseupHeader.vue?vue&type=script&lang=js&"
import style0 from "./RiseupHeader.vue?vue&type=style&index=0&id=26a690f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a690f4",
  null
  
)

export default component.exports